export enum Environment {
  LOCAL = 'local',
  DEVELOPMENT = 'dev',
  STAGING = 'staging',
  PRODUCTION = 'prod',
  TEST = 'test',
  FEAT_1 = 'feat-1',
  FEAT_2 = 'feat-2',
  FEAT_3 = 'feat-3',
  FEAT_4 = 'feat-4',
  FEAT_5 = 'feat-5',
}

export enum Workspace {
  DEVELOPMENT = Environment.DEVELOPMENT,
  STAGING = Environment.STAGING,
  PRODUCTION = Environment.PRODUCTION,
}

export enum NodeEnv {
  LOCAL = 'local',
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production',
  TEST = 'test',
}

export enum ApplicationName {
  BACKEND = 'PHENOM-BACKEND',
  TABLE_SERVER = 'TABLE-SERVER',
  TOURNAMENT_TABLE_SERVER = 'TOURNAMENT-TABLE-SERVER',
  BACKOFFICE = 'BACKOFFICE',
  TOURNAMENT_SERVER = 'TOURNAMENT_SERVER',
  TRANSACTION_PROCESSOR = 'TRANSACTION_PROCESSOR',
}

export const projectName = 'phenom-poker';
export const tableApplicationNames = [ApplicationName.TABLE_SERVER, ApplicationName.TOURNAMENT_TABLE_SERVER];

const isEnv = (env: string | undefined): env is Environment => Object.values(Environment).includes(env as Environment);

export const environment = (() => {
  if (process.env.ENVIRONMENT && isEnv(process.env.ENVIRONMENT)) return process.env.ENVIRONMENT;
  if (process.env.REACT_APP_ENV && isEnv(process.env.REACT_APP_ENV)) return process.env.REACT_APP_ENV;
  if (process.env.NODE_ENV === NodeEnv.TEST) return Environment.TEST;
  return Environment.LOCAL;
})();

export const workspace = (() => {
  switch (environment) {
    case Environment.LOCAL:
    case Environment.TEST:
    case Environment.DEVELOPMENT:
      return Workspace.DEVELOPMENT;
    case Environment.PRODUCTION:
      return Workspace.PRODUCTION;
    default:
      return Workspace.STAGING;
  }
})();
